import * as Sentry from '@sentry/browser'

function getEnvironment () {
  switch (document.location.hostname) {
    case 'webmango-staging.anu.edu.au': {
      return 'staging'
    }
    case 'webmango.anu.edu.au': {
      return 'production'
    }
    default: {
      return 'development'
    }
  }
}

Sentry.init({
  dsn: 'https://e81c0225cebe4ee39717c36565d382b7@sentry.io/1554305',
  environment: getEnvironment(),
  release: process.env.VERSION
})

console.info('WebMango Version –', process.env.VERSION)
console.info(window.navigator.userAgent) // diagnostic info



// WEBPACK FOOTER //
// ./src/diagnostics.js